import React from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useAppTheme } from "../theme/useAppTheme";

export default function MainLayout() {
  const themeColors = useAppTheme();

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: themeColors.scaffoldGradientColors,
        color: themeColors.scaffoldText,
      }}
    >
      <Sidebar />
      <div className="app-content">
        <ToastContainer position="top-center" autoClose={3000} />
        <Outlet />
      </div>
    </div>
  );
}
